import React from "react";

const PhysicianManagementIcon = ({ style = {} }) => {
  return (
    <svg style={style} width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.9216 12.8821C19.1554 13.3267 19.3906 13.759 19.6136 14.3015C20.069 15.3891 20.6251 16.4251 20.9092 17.5494C21.9697 21.8823 18.5028 26.2029 14.1931 26.3633C14.1428 26.3756 14.0938 26.3756 14.0449 26.3756C9.68755 26.3022 6.11874 21.9299 7.19279 17.5494C7.46469 16.4251 8.03163 15.3877 8.46532 14.3001C8.69916 13.7332 8.95883 13.2886 9.19268 12.8318"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.4714 24.5062C31.4802 24.9168 31.4068 25.3251 31.2557 25.707C31.1046 26.0889 30.8788 26.4369 30.5915 26.7304C30.3042 27.0239 29.9612 27.2571 29.5826 27.4164C29.204 27.5756 28.7974 27.6577 28.3867 27.6578C27.9759 27.6579 27.5693 27.576 27.1906 27.4169C26.812 27.2578 26.4689 27.0248 26.1814 26.7314C25.894 26.438 25.668 26.0901 25.5167 25.7083C25.3655 25.3264 25.2919 24.9182 25.3005 24.5076C25.3005 23.6891 25.6256 22.9041 26.2044 22.3253C26.7832 21.7465 27.5681 21.4214 28.3866 21.4214C29.2051 21.4214 29.9901 21.7465 30.5689 22.3253C31.1477 22.9041 31.4728 23.6891 31.4728 24.5076L31.4714 24.5062Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.3852 27.5936V27.9009C28.3852 29.7836 27.6373 31.5892 26.306 32.9205C24.9747 34.2518 23.1691 34.9997 21.2864 34.9997C19.4036 34.9997 17.598 34.2518 16.2667 32.9205C14.9354 31.5892 14.1875 29.7836 14.1875 27.9009V26.3591"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.3672 4.67334H17.9809"
        stroke="black"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.3672 9.58643H17.9809"
        stroke="black"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="1.67329"
        cy="1.67329"
        r="1.67329"
        transform="matrix(-1 0 0 1 29.6934 7.91333)"
        fill="white"
        stroke="black"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="1.67329"
        cy="1.67329"
        r="1.67329"
        transform="matrix(-1 0 0 1 23.8369 3)"
        fill="white"
        stroke="black"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default PhysicianManagementIcon;
